/* Steph Brooke Studio: WCAG 2.1 AA fixes.
   1.4.13: menus opened by mouse hover close with Escape (the theme only handled Escape while
   keyboard focus was inside the menu). After Escape the menu stays closed until the pointer
   leaves it, so the next mouse movement doesn't reopen it straight away. */
(function () {
  'use strict';
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details.site-nav__details[open]').forEach(function (d) {
      d.removeAttribute('open');
      d.setAttribute('aria-expanded', 'false');
      d.dataset.escClosed = '1';
      d.addEventListener('mouseleave', function () { delete d.dataset.escClosed; }, { once: true });
    });
  });
  // Block the theme's hover-to-open while Escape-closed (capture on the wrapper runs first).
  document.addEventListener('mouseover', function (e) {
    var d = e.target.closest && e.target.closest('details.site-nav__details');
    if (d && d.dataset.escClosed === '1') e.stopPropagation();
  }, true);
})();

/* ===== Whole-site pass (WCAG 2.1 AA) ===== */
(function () {
  'use strict';

  // A1 (4.1.2): product gallery slides that are aria-hidden must not be focusable. Flickity toggles
  // aria-hidden as the slide changes, so mirror it onto `inert`. Only the product gallery and the
  // hidden "scrollable" grid: card carousels show several aria-hidden cards at once and must stay usable.
  var GALLERY = '.product-main-slide, .new-grid.visually-invisible';
  function syncInert(el) {
    if (!el.matches || !el.matches(GALLERY)) return;
    var hidden = el.getAttribute('aria-hidden') === 'true';
    if (hidden !== el.inert) el.inert = hidden;
  }

  // A3 (4.1.2): options unavailable for the chosen size are faded via [data-disabled] but still
  // announced as available. Expose the state to screen readers.
  function syncDisabled(input) {
    if (!input.matches || !input.matches('input[type=radio]')) return;
    if (input.hasAttribute('data-disabled')) input.setAttribute('aria-disabled', 'true');
    else if (input.getAttribute('aria-disabled') === 'true') input.removeAttribute('aria-disabled');
  }

  // A6 (4.1.2): name the price-range slider handles.
  function nameSliders(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('.noUi-handle-lower:not([aria-label])').forEach(function (h) { h.setAttribute('aria-label', 'Minimum price'); });
    (root.querySelectorAll ? root : document).querySelectorAll('.noUi-handle-upper:not([aria-label])').forEach(function (h) { h.setAttribute('aria-label', 'Maximum price'); });
  }

  // B1 (1.1.1): fallback <img> inside <video> is never shown; mark it decorative.
  function videoFallbacks(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('video img:not([alt])').forEach(function (i) { i.setAttribute('alt', ''); });
  }

  function sweep(root) {
    root = root || document;
    root.querySelectorAll(GALLERY).forEach(syncInert);
    root.querySelectorAll('input[type=radio][data-disabled], input[type=radio][aria-disabled]').forEach(syncDisabled);
    nameSliders(root);
    videoFallbacks(root);
  }

  function start() {
    sweep(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') {
          if (m.attributeName === 'aria-hidden') syncInert(m.target);
          else if (m.attributeName === 'data-disabled') syncDisabled(m.target);
        } else if (m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) { var n = m.addedNodes[j]; if (n.nodeType === 1) { syncInert(n); sweep(n); } }
        }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'data-disabled'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 2.4.7: tell keyboard focus from a tap or click. Flickity calls focus() on its slider when pressed, which
   counts as :focus-visible, so the slider outline (sbs-a11y.css) also needs html[data-sbs-keyboard]. */
(function () {
  'use strict';
  var root = document.documentElement;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') root.setAttribute('data-sbs-keyboard', '');
  }, true);
  document.addEventListener('pointerdown', function () {
    root.removeAttribute('data-sbs-keyboard');
  }, true);
})();
